export const SET_FILTER_COUNT = "SET_FILTER_COUNT"
export const SET_CURRENT_FILTER = "SET_CURRENT_FILTER"
